import styled from "styled-components";
import ImageBackground from "../../../../assets/images/carro.jpg";

export const NewsSec = styled.div`
  padding: 5rem 5rem;
  @media screen and (max-width: 414px) {
    padding: 3rem 3rem;
  }
  width: 100%;
  background-color: #eef7fd;
`;
export const NewsContainer = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NewsCard = styled.a`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 438px;
  min-width: 230px;
  padding: 5rem 4%;
  justify-content: flex-end;
  background-color: black;
  text-decoration: none;
  &:after {
    content: "";
    background-image: url(${ImageBackground});
    background-size: cover;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    opacity: 0.6;
  }
`;
export const CategoryFlag = styled.div`
  font-size: 10px;
  background-color: #90cbf0;
  color: #071242;
  padding: 5px 0;
  width: 60px;
  text-align: center;
  margin-bottom: 1.5rem;
  z-index: 999;
`;
export const NoticiaTitle = styled.div`
  color: #fff;
  font-size: 2.5rem;
  text-align: left;
  margin-bottom: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  z-index: 999;
`;
export const NoticiaDate = styled.div`
  font-size: 1.2rem;
  color: #fff;
  margin-bottom: 1.5rem;
  z-index: 999;
`;
export const NoticiaSubtitle = styled.div`
  color: #fff;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-size: 1.5rem;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  z-index: 999;
  @media screen and (max-width: 768px) {
    text-align: justify;
  }
`;

export const LoadingCard = styled.div`
  width: 100%;
  min-width: 230px;
  height: 368px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #777;
  margin: 0 0 50px 0;
`;
